import {
  filterCompletedCalendarTasks,
  getCompletedTasksInRangeFilterOptions,
} from '@griply/utils';
import { useMemo } from 'react';
import { useFilteredTasksQuery } from 'shared/hooks/queries/use-filtered-tasks-query';
import { useUser } from 'shared/hooks/use-user';
import { Task } from 'shared/types/task';
import { Timestamp } from 'shared/types/timestamp';

// Window-bounded on purpose — the calendar's main read is uncompleted-only, and an unbounded all-completed read would defeat the windowing.
export const useCompletedTasksInRange = (
  start: Timestamp,
  end: Timestamp,
): Task[] => {
  const user = useUser();

  const filterOptions = useMemo(
    () => getCompletedTasksInRangeFilterOptions(start, end),
    [start, end],
  );

  const { data: tasks } = useFilteredTasksQuery(user?.uid, filterOptions);

  return useMemo(() => filterCompletedCalendarTasks(tasks ?? []), [tasks]);
};
